// extracted by mini-css-extract-plugin
export var actions = "Action-module--actions--j9bMQ";
export var component = "Action-module--component--3Awel";
export var componentInner = "Action-module--componentInner--QzZHG";
export var heading = "Action-module--heading--c7aQ3";
export var label = "Action-module--label--LvHm1";